import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LockScreenService {
    private lockScreenSubject = new BehaviorSubject<boolean>(localStorage.getItem('isLocked') === 'true');
    lockScreen$ = this.lockScreenSubject.asObservable();

    constructor() {}

    lock() {
        localStorage.setItem('isLocked', 'true');
        this.lockScreenSubject.next(true);
    }

    unLock() {
        localStorage.setItem('isLocked', 'false');
        this.lockScreenSubject.next(false);
    }
}
